import type { WidgetOptions } from "@/shared/types/widgetOptions";
import type { MenuOptionComponentProps } from "../../types";
import { DocumentReNameInput } from "../../ui/DocumentRenameInput/DocumentRenameInput";
import { DocumentTurnPage } from "../../ui/DocumentTurnPage/DocumentTurnPage";
import { GroupButtons } from "../../ui/GroupButtons/GroupButtons";
import { MenuEditButton } from "../../ui/MenuOption/MenuEditButton";
import { TextSizeButton } from "../../ui/TextSizeButton/TextSizeButton";
import { WidthInput } from "../../ui/WidthInput/WidthInput";

export const MENU_OPTION_SPECIAL_COMPONENTS: Partial<
    Record<WidgetOptions, React.FC<MenuOptionComponentProps>>
> = {
    textSize: ({ activeSubMenu, setActiveSubMenu }) => (
        <TextSizeButton activeSubMenu={activeSubMenu} setActiveSubMenu={setActiveSubMenu} />
    ),

    group: ({ setActiveSubMenu }) => <GroupButtons setActiveSubMenu={setActiveSubMenu} />,

    documentName: ({ setActiveSubMenu }) => (
        <DocumentReNameInput setActiveSubMenu={setActiveSubMenu} />
    ),
    documentTurnPage: () => <DocumentTurnPage />,

    width: ({ setActiveSubMenu }) => <WidthInput setActiveSubMenu={setActiveSubMenu} />,
    mobileEdit: ({ name, setActiveSubMenu }) => (
        <MenuEditButton name={name} setActiveSubMenu={setActiveSubMenu} />
    ),
};
